import '@bingads-webui/kendo/kendo.data';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { DateInlineEditableColumnPrompt } from '@bingads-webui-campaign/date-inline-edit-prompt';
import { convertUTCDateToMachineDate, getCurrentDate, formatDate } from '@bingads-webui-campaign/summary-grid-helper';

import { getDateSaveAction } from '../inline-editable/date-save';

const fieldName = 'StartDate';

export class StartDateColumn extends CampaignuiBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    const title = i18n.getString('ColumnName_StartDate');

    super({
      name: fieldName,
      property: [fieldName, 'UseCampaignLevelDates'],
      title,
      editable: true,
      sortable: fieldName,
      type: 'string',
      helpId: 'pop_BA_Campaigns_StartDateColumn',
      enableEdit: item => item.UseCampaignLevelDates && new Date(item.StartDate) > getCurrentDate(),
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    if (item.$total) {
      return '';
    }

    return item.UseCampaignLevelDates && item.StartDate
      ? formatDate(item.StartDate, this.i18n)
      : this.i18n.getString('StartDate_None');
  }

  onPrompt({ position, item, newPosition }) {
    const saveDate = getDateSaveAction(fieldName, 'CampaignsGridStartDateColumn');

    const options = {
      position: this.isForVNext ? newPosition : position,
      isForVNext: this.isForVNext,
      item,
      view: this.view,
      i18n: this.i18n,
      fieldName,
      allowNoDate: false,
      selectedDate: convertUTCDateToMachineDate(new Date(item.StartDate), this.i18n),
      updater: saveDate,
    };

    if (item.EndDate) {
      options.maxDate = convertUTCDateToMachineDate(new Date(item.EndDate), this.i18n);
    }
    return DateInlineEditableColumnPrompt(options);
  }
}
